import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';

import ACTIONS from 'constants/action';

const getIconName = (direction) =>
  direction === ACTIONS.ARROW_NEXT ? 'arrow-forward' : 'arrow-backwards';

const ArrowButton = ({ href = null, direction, onClick, ...rest }) => {
  if (href) {
    return (
      <NextLink href={href} prefetch={false} passHref>
        <Button
          as="a"
          icon={<Icon name={getIconName(direction)} />}
          size="size2"
          type="neutral-ghost"
          onClick={onClick}
          {...rest}
        />
      </NextLink>
    );
  }

  return (
    <Button
      icon={<Icon name={getIconName(direction)} />}
      size="size2"
      type="neutral-ghost"
      onClick={onClick}
      {...rest}
    />
  );
};

ArrowButton.propTypes = {
  href: PropTypes.string,
  direction: PropTypes.oneOf([ACTIONS.ARROW_PREV, ACTIONS.ARROW_NEXT])
    .isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ArrowButton;
